import { SquareWithRoundBordersShape } from '../SquareWithRoundBordersShape';
import { graphCurrencyFormatter, graphNumberFormatter } from '../utils';

import styles from './graph-tooltips.module.scss';

export function SalesByChannelsTooltip({ allData, isGmvMetric, currency, dataKey }) {
  const formatValue = ({ value, shouldFormatAsGmv = isGmvMetric }) =>
    shouldFormatAsGmv ? graphCurrencyFormatter(value, currency) : graphNumberFormatter(value);

  return (props) => {
    const {
      color,
      label,
      data: { id },
    } = props.datum;

    const gmvData = allData.gmv.find((datum) => datum.id === id);
    const unitsData = allData.units.find((datum) => datum.id === id);
    const ordersData = allData.orders.find((datum) => datum.id === id);

    const currentDataMapping = {
      gmv: gmvData,
      units: unitsData,
      orders: ordersData,
    };

    const { value: valueToDisplayAsPercentage = 0, total: totalValue = 0 } = currentDataMapping?.[dataKey] || {};

    const otherValue = dataKey === 'units' && currentDataMapping?.gmv?.total;

    return (
      <div className={styles.tooltipWrapper}>
        <header>
          <svg height="14" width="14">
            <SquareWithRoundBordersShape fill={color} />
          </svg>
          {label}
        </header>
        <main>
          <span className={styles.percentage}>{valueToDisplayAsPercentage}%</span>
          <span className={styles.metric}>
            <strong>{formatValue({ value: totalValue })}</strong>
          </span>
          <span className={styles.otherMetric}>
            {otherValue
              ? `(${formatValue({
                  value: otherValue,
                  shouldFormatAsGmv: true,
                })})`
              : ''}
          </span>
        </main>
      </div>
    );
  };
}
